/*requires hei.js */
//
// Standard javascript for most/all HEI forms
//
//  Ben Ramey
//  October 2009
//
HEIJS.Form = function (forms)
{
  this.forms = forms || $("div.form");
  this.afterPageValidation = new HEIJS.Event();

  if (this.forms.length == 0)
    return;

  if ($("body").is(".popup")
      && /CloseOnSave=true/.test(document.location.search)
      && $(this.forms[0]).attr("SaveStatus").toLowerCase() == "success")
  {
    window["SaveStatus"] = $(this.forms[0]).attr("SaveStatus");
    window.close();
  }

  this.pageBottom = $("div.bottom");
  this.addForms(this.forms);
};

HEIJS.Form.prototype =
{
  //
  // Properties
  //
  forms: null,
  pageBottom: null,
  // events
  afterPageValidation: null,

  //
  // Methods
  //
  // works with the ASP.NET validators to determine if the form
  // is valid or not
  pageIsValid: function ()
  {
    if (typeof (Page_IsValid) !== "undefined")
      return Page_IsValid;
    else
      return true;
  },

  resizeForms: function ()
  {
    HEIJS.controls.resizeControls($("div.controls.auto-adjusts-height-to-page"));
  },

  addForms: function (newForms)
  {
    if (this.forms)
      this.forms = this.forms.add(newForms);
    else
      this.forms = newForms;

    this.initializeDateInputs(newForms);
    this.initializeValidators(newForms);

    this.setupEvents(newForms);
    newForms.filter(":has(.auto-adjusts-height-to-page)").css("margin-bottom", -1 * (this.pageBottom.outerHeight() + 2));

    if (newForms.length > 0)
    {
      var self = this;
      newForms.each(function ()
      {
        if (typeof (Page_ClientValidate) != "undefined")
          self.validate($(this), true);
      });
    }
  },

  validate: function (formElement, isInitialValidation)
  {
    var validationGroup = formElement.attr("id");
    isInitialValidation = isInitialValidation || false;
    if (formElement.find("div.netbuilderform").length > 0)
    {
      validationGroup = formElement.find("div.netbuilderform").attr("id");
    }

    var isValid = Page_ClientValidate(validationGroup, isInitialValidation);
    Page_BlockSubmit = false;
    return isValid;
  },

  initializeDateInputs: function (forms)
  {
    if ($("input.date-input", forms).length > 0 && typeof ($.datepicker) != "undefined")
    {
      $("input.date-input", forms).datepicker({
        showOn: 'button',
        buttonImageOnly: true,
        buttonImage: HEIJS.context.getResourceUri('/resources/images/icons/datetime.png'),
        changeYear: true,
        changeMonth: true,
        duration: 0,
        gotoCurrent: true
      });
    }
  },

  initializeValidators: function (forms)
  {
    $("div.field span.validator", forms).aspNetValidator();
  },

  handleActionButtonClick: function (button, e)
  {
    if (button.is("[causesvalidation=True]"))
    {
      if (button.parents("div.form:first").find("span.validator").length > 0)
      {
        // wait for validation to be done to show status message or not
        // the third param to HEIJS.EventHandler makes sure this event
        // is only called once
        this.afterPageValidation.AddHandler(
          new HEIJS.EventHandler(
            function ()
            {
              if (this.pageIsValid())
              {
                this.showSystemStatusForButton(button, e);
              }
            },
            this,
            true
          ));
      }
      else
      {
        if (this.pageIsValid())
        {
          this.showSystemStatusForButton(button, e);
        }
      }
    }
    else
    {
      this.showSystemStatusForButton(button, e);
    }
  },

  showSystemStatusForButton: function (button, e, container)
  {
    var hasEvent = (typeof (e) != "undefined" && e != null);
    if (hasEvent && button.is("[isajax=True]"))
    {
      e.preventDefault();
    }

    if (hasEvent && button.is("[autoshowstatusmessage=False]"))
    {
      return;
    }

    if (button.is("[showslocalstatus=True]"))
    {
      var localStatus = HEIJS.page.systemStatus.showLocal(
        button.attr("statusmessage"),
        container || button.parents("div.form:first")
      );

      button[0].hideLocalStatus = function () { localStatus.remove(); };
    }
    else
    {
      HEIJS.page.systemStatus.show(button.attr("statusmessage"));
    }
  },

  setupEvents: function (forms)
  {
    var self = this;

    // action buttons
    $("div.action-buttons .button,div.action-buttons .small-button", forms)
      .click(function (e) { self.handleActionButtonClick($(this), e); })
      .filter("[showslocalstatus=True]")
      .each(function (i, d) { d.hideLocalStatus = function () { }; });
  }
};

$(document).ready(function ()
{
  // in when events are triggered on elements by jQuery like "element.change()"
  // the window.event values are not set correctly, so the ValidatorOnChange function
  // won't work because there is no target.  However, jQuery passes this data to the anonymous
  // onchange function that it assigned to that element for validation, but the anonymous function
  // just doesn't pass it on if it's IE.  This remedies this by getting the first argument passed to the
  // anonymous calling function (window.ValidatorOnChange.caller)
  if ($.browser.msie
      && typeof (window.ValidatorOnChange) != "undefined"
      && $.isFunction(window.ValidatorOnChange))
  {
    window.OldValidatorOnChange = window.ValidatorOnChange;
    window.ValidatorOnChange = function (event)
    {
      if (window.ValidatorOnChange.caller.arguments[0])
      {
        event = window.ValidatorOnChange.caller.arguments[0];
      }

      window.OldValidatorOnChange(event);
    }
  }

  // override some ASP.NET javascript validation
  // functions to work with the aspNetValidator
  if (typeof (window.ValidatorUpdateDisplay) != "undefined"
      && $.isFunction(window.ValidatorUpdateDisplay))
  {
    window.OldValidatorUpdateDisplay = window.ValidatorUpdateDisplay;
    window.ValidatorUpdateDisplay = function (val)
    {
      // only intended to work with new, standard style, form controls
      // and fields
      if ($(val).is(".validator")
          && $(val).parents("div.field").length > 0
          && typeof (val.display) == "string"
          && val.display == "Dynamic")
      {
        $(val).aspNetValidator("updateDisplay");
        return;
      }
      else
      {
        window.OldValidatorUpdateDisplay(val);
      }
    }
  }

  if (typeof (window.Page_ClientValidate) != "undefined"
      && $.isFunction(window.Page_ClientValidate))
  {
    // the validationgroup for a form control should also
    // be the client id of the form div
    window.OldPage_ClientValidate = window.Page_ClientValidate;
    window.Page_ClientValidate = function (validationGroup, isInitialValidation)
    {
      isInitialValidation = isInitialValidation || false;

      if (!HEIJS.page.formMessages || !validationGroup)
      {
        window.OldPage_ClientValidate(validationGroup);
        return Page_IsValid;
      }
      else
      {
        var valGroupElement = $("#" + validationGroup);
        var form = valGroupElement;

        if (!valGroupElement.is("div.form"))
        {
          form = valGroupElement.parents("div.form:first");
        }

        var formMessages = HEIJS.page.formMessages.getHandler(form.attr("id"));

        if (!formMessages || form.attr("id") === 'login-page')
        {
          window.OldPage_ClientValidate(validationGroup);
          HEIJS.page.form.afterPageValidation.Trigger();
          return Page_IsValid;
        }

        formMessages.clearErrorMessages();
        window.OldPage_ClientValidate(validationGroup);

        if (Page_IsValid)
        {
          formMessages.hideErrorMessages();
        }
        else if (!isInitialValidation)
        {
          if (form.attr("showdetailederrorsummary") == "True")
          {
            formMessages.showAllErrorMessages("This form contains errors");
          }
          else
          {
            formMessages.showErrorMessage("This form contains errors. Please correct them before continuing as indicated below.");
          }
        }

        HEIJS.page.form.afterPageValidation.Trigger();
        return Page_IsValid;
      }
    }
  }

  // we want this to work slightly differently so that
  // a validator's display is not updated if it's not in the same
  // validation group as the one being validated
  if (typeof (window.ValidatorValidate) != "undefined"
      && $.isFunction(window.ValidatorValidate))
  {
    window.OldValidatorValidate = window.ValidatorValidate;
    window.ValidatorValidate = function (val, validationGroup, event)
    {
      if (typeof (val) == "undefined")
        return;

      val.isvalid = true;
      var validationGroupMatches = IsValidationGroupMatch(val, validationGroup);
      if ((typeof (val.enabled) == "undefined" || val.enabled != false)
          && validationGroupMatches)
      {
        if (typeof (val.evaluationfunction) == "function")
        {
          val.isvalid = val.evaluationfunction(val);
          if (!val.isvalid
              && Page_InvalidControlToBeFocused == null
              && typeof (val.focusOnError) == "string"
              && val.focusOnError == "t")
          {
            ValidatorSetFocus(val, event);
          }
        }
      }

      if (validationGroupMatches)
      {
        ValidatorUpdateDisplay(val);
      }
    }
  }

  HEIJS.page.form = new HEIJS.Form();
});